import React from "react";
import { Phone, Globe, Heart } from "lucide-react";
import SEO from "../../components/SEO";
import { useLanguage } from "../../context/LanguageContext";

export default function Crisis() {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen bg-red-50 dark:bg-red-950/20 text-gray-800 dark:text-gray-100 font-body py-20 px-6">
            <SEO 
              title={t("crisis_title")} 
              description={t("crisis_desc")} 
              url="/crisis" 
            />

            <main className="max-w-3xl mx-auto text-center space-y-12">

                <div className="space-y-6">
                    <div className="inline-block p-4 bg-red-100 dark:bg-red-900/50 rounded-full text-red-600 dark:text-red-400 mb-4">
                        <Phone className="w-12 h-12" />
                    </div>
                    <h1 className="text-4xl font-display font-bold text-red-700 dark:text-red-400">
                        {t("crisis_title")}
                    </h1>
                    <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed">
                        {t("crisis_desc")}
                        <br />
                        <strong>{t("crisis_hope")}</strong>
                    </p>
                </div>

                <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-red-100 dark:border-red-900/50 text-left space-y-8">

                    {/* India */}
                    <div>
                        <h3 className="flex items-center gap-2 font-bold text-xl mb-3">
                            <span className="text-2xl">🇮🇳</span> India Helplines
                        </h3>
                        <ul className="space-y-3">
                            <Helpline name="Vandrevala Foundation" number="1860-266-2345" desc="24/7 Counseling" />
                            <Helpline name="AASRA" number="91-9820466726" desc="24/7 Suicide Prevention" />
                            <Helpline name="KIRAN (Govt MH Rehab)" number="1800-599-0019" desc="24/7 Mental Health Support" />
                        </ul>
                    </div>

                    <hr className="border-gray-100 dark:border-gray-700" />

                    {/* Global */}
                    <div>
                        <h3 className="flex items-center gap-2 font-bold text-xl mb-3">
                            <Globe className="w-5 h-5 text-blue-500" /> Global Resources
                        </h3>
                        <div className="space-y-2 text-gray-600 dark:text-gray-300">
                            <p><strong>USA:</strong> 988 (Suicide & Crisis Lifeline)</p>
                            <p><strong>UK:</strong> 111 (NHS) or 116 123 (Samaritans)</p>
                            <p><strong>Worldwide Database:</strong> <a href="https://findahelpline.com" target="_blank" rel="noreferrer" className="text-brand-blue underline">Find A Helpline</a></p>
                        </div>
                    </div>

                </div>

                <div className="text-sm text-gray-500 max-w-lg mx-auto">
                    {t("crisis_platform_note")}
                    <br />
                    {t("crisis_instruction")}
                </div>

            </main>
        </div>
    );
}

function Helpline({ name, number, desc }) {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
            <div>
                <div className="font-semibold text-gray-900 dark:text-white">{name}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">{desc}</div>
            </div>
            <a href={`tel:${number}`} className="mt-2 sm:mt-0 px-4 py-2 bg-green-100 text-green-700 rounded-lg font-bold hover:bg-green-200 transition-colors text-center inline-block">
                {number}
            </a>
        </div>
    )
}
